module.exports = __webpack_public_path__ + "img/file-doc.8ea8fd07.svg";